module.exports = __webpack_public_path__ + "img/spidercracks.ba96078b.jpeg";